import { createSlice } from '@reduxjs/toolkit';

export const CHAT_TYPE = {
    chatroom: 0,
    //   plan : 1,
    //   analysis : 2,
    privatechat: 3,
    intlchat: 4,
};

export const COMMENT_TYPE = {
    DESIGNER_COMMENT: 'DESIGNER_COMMENT',
    DOCTOR_REQUEST: 'DOCTOR_REQUEST',
};

const initialState = {
    patientInfoData: {
        id: null,
        first_name: '',
        last_name: '',
        case_status: '',
        case_type: null,
        isSmileDesign: false,
    },
    deletableMsgMap: new Map(),
    draftChatMsg: '',
    draftPrivateChatMsg: '',
    draftIntlChatMsg: '',
    /**
     * @typedef {Object} DraftComment
     * @property {string} comment
     * @property {string} request
     */
    /** @type {Object.<string, DraftComment>} */
    draftComment: {},
    unreadCounts: {
        chatRoom: 0,
        privateChat: 0,
        intlChat: 0,
        total: 0,
    },
};

const clinicalSimulationSlice = createSlice({
    name: 'clinicalSimulation',
    initialState,
    reducers: {
        setPatientInfoData: (state, action) => {
            state.patientInfoData = action.payload;
            return state;
        },
        clearPatientInfoData: (state) => {
            state = initialState;
            return state;
        },
        setDeletableMsgMap: (state, action) => {
            state.deletableMsgMap = action.payload;
            return state;
        },
        resetDeletableMsgMap: (state) => {
            state.deletableMsgMap = new Map();
            return state;
        },
        setDraftChatMessage: (state, action) => {
            const type = action?.payload?.type || 0;
            switch (type) {
                case CHAT_TYPE.privatechat:
                    state.draftPrivateChatMsg = action?.payload?.msg || '';
                    break;
                case CHAT_TYPE.intlchat:
                    state.draftIntlChatMsg = action?.payload?.msg || '';
                    break;
                default:
                    state.draftChatMsg = action?.payload?.msg || '';
                    break;
            }
            return state;
        },
        setDraftComment: (state, action) => {
            const { currentPlanId, value, type } = action.payload || {};
            const prevDraft = state.draftComment[currentPlanId] || { request: '', comment: '' };
            const updatedDraft = { ...prevDraft };

            if (type === COMMENT_TYPE.DOCTOR_REQUEST) {
                updatedDraft.request = value || '';
            } else {
                updatedDraft.comment = value || '';
            }

            state.draftComment[currentPlanId] = updatedDraft;
            return state;
        },
        resetDraftComment: (state) => {
            state.draftComment = {};
            return state;
        },
        resetAllDraftChatMsg: (state) => {
            state.draftChatMsg = '';
            state.draftPrivateChatMsg = '';
            state.draftIntlChatMsg = '';
            return state;
        },
        setUnreadCounts: (state, action) => {
            const { chatRoom = 0, privateChat = 0, intlChat = 0 } = action.payload;
            state.unreadCounts = {
                chatRoom,
                privateChat,
                intlChat,
                total: chatRoom + privateChat + intlChat,
            };
            return state;
        },
    },
});

export const {
    setPatientInfoData,
    clearPatientInfoData,
    setDeletableMsgMap,
    resetDeletableMsgMap,
    setDraftChatMessage,
    setDraftComment,
    resetDraftComment,
    resetAllDraftChatMsg,
    setUnreadCounts,
} = clinicalSimulationSlice.actions;

export const clinicalSimulationReducer = clinicalSimulationSlice.reducer;
